/**
 * Flag globale "logout per sessione scaduta in corso".
 *
 * Durante il logout (401 + refresh falliti) resta a schermo un solo messaggio:
 * il modal centrale `HostSessionExpiredDialog`. La `ErrorDialog` condivisa da
 * tutti i componenti figli, invece, non deve renderizzare: cosi' evitiamo la
 * doppia modal senza dover modificare il catch di ogni singola schermata.
 *
 * Usiamo un flag a livello di modulo (non React state) di proposito: la
 * `ErrorDialog` di un figlio puo' essere montata DOPO l'evento di logout (mount
 * condizionale nel catch). Un flag di modulo viene letto al momento del render,
 * indipendentemente dal timing di montaggio/sottoscrizione.
 *
 * Non serve un reset: il logout reindirizza al login (full reload), quindi il
 * modulo viene reinizializzato.
 */
let sessionLoggingOut = false;

export function markSessionLoggingOut() {
  sessionLoggingOut = true;
}

export function isSessionLoggingOut() {
  return sessionLoggingOut;
}
